import { signal } from "@preact/signals";
import { createSignal } from "solid-js";
import { SurvivorClient } from "#root/bin/server/client/survivor";

const [innerUseAdvocateCopy, setInnerUseAdvocateCopy] = createSignal(false);
const preactUseAdovcateCopy = signal(false); // TODO: remove this once we just use Solid

const [
  innerShouldShowRecoveryUpdateModal,
  setInnerShouldShowRecoveryUpdateModal,
] = createSignal(false);

// Global Application State ////////////////////////////////////////////////////
// There's a few toggles that are needed for various small operations around the site; this serves to collect them.
// Think carefully before adding something here, we want to keep our global state as small as possible.
export const globalState = {
  client: new SurvivorClient(),

  // Matching Survey ///////////////////////////////////////////////////////////
  shouldShowMatchingSurvey: signal(false),
  matchingSurveyLinkedEntry: signal(""),

  // Recovery Update ///////////////////////////////////////////////////////////
  shouldShowRecoveryUpdateModal: innerShouldShowRecoveryUpdateModal,
  setShouldShowRecoveryUpdateModal: setInnerShouldShowRecoveryUpdateModal,

  // Incident Log //////////////////////////////////////////////////////////////
  incidentLogForAttorney: signal(false),

  // Feature Flags /////////////////////////////////////////////////////////////
  useAdvocateCopy: innerUseAdvocateCopy,
  preactUseAdovcateCopy: preactUseAdovcateCopy, // TODO: remove this once we just use Solid
};

// TODO: remove this debugging tool, or integrate it in better.
window.__internalCallistoGlobalState = globalState;

/**
 * Transform any feature flags into usable signals for other parts of the app.
 * TODO: there's probably a better way to do this using stores?
 */
export async function bootstrapFeatureFlags() {
  const l = await globalState.client.getFlag("UI_ENV_USE_ADVOCATE_COPY");
  const usingAdvocateCopy = l === "1";
  setInnerUseAdvocateCopy(usingAdvocateCopy);
  preactUseAdovcateCopy.value = usingAdvocateCopy; // TODO: remove this once we just use Solid
}
